window.booklistQuantities = Object.assign(window.booklistQuantities || {}, {
  "brightonstateschool": {
    "2026": {
      "prep": {
        "100-gsm-165x240-minisaurus-scrapbook-64-page": 2,
        "a4-paper-ream": 1,
        "bic-whiteboard-marker-pens": 8,
        "bostik-blu-glue-sticks": 5,
        "box-tissues": 1,
        "clipboard": 1,
        "colby-a3-gusseted-handy-pouch": 1,
        "colored-pencils-12-pack-triangular-or-jumbo-only": 1,
        "crayola-my-first-crayons": 1,
        "craypas-12-staedlter-oil-pastels-12s": 1,
        "display-folder-20-pockets": 1,
        "felt-pens-marathon-not-connector": 2,
        "hb-faber-castell-junior-triangular-pencils": 10,
        "headphones1": 1,
        "library-bag": 1,
        "manilla-folder-set-green-blue-yellow-purple-each": 1,
        "my-school-scrapbook-yellow-version-half-page-lines": 1,
        "paintbrush-jassart-8": 1,
        "queensland-targeting-handwriting-prep": 1,
        "scissors": 1,
        "scrapbooks": 4,
        "watercolour-paint-palette-12-colour-set": 1,
        "year-1-ruled-exercise-book": 1
      },
      "year1": {
        "a3-handy-pouch": 2,
        "a3-sketch-book-spirax-533": 1,
        "a4-exercie-book-18mm-rules-with-margin": 2,
        "a4-exercise-books-year-1-lines-48-page": 3,
        "a4-paper-ream": 1,
        "a4-whiteboard": 1,
        "bostick-glustick-35grams": 6,
        "box-tissues": 1,
        "clipboard": 1,
        "eraser": 4,
        "faber-castell-10-pack-connector-pens-please-label": 2,
        "faber-castell-2-hole-tub-sharpener": 1,
        "faber-castell-coloured-pencils-triangular-12-s": 2,
        "faber-castell-hb-pencils-triangular-grip": 10,
        "headphones1": 1,
        "library-bag": 1,
        "medium-pencil-case-fits-ruler": 1,
        "olympic-minisaurus-scrapbook-64-page": 2,
        "paint-shirt-cotton-long-sleeve-eg-old-business-shirt": 1,
        "paintbrush-jasart-579-size-8": 1,
        "plastic-document-wallets": 4,
        "scissors": 1,
        "scrap-books-64-page-stapled-please": 6,
        "soundwave-foundation-spelling-chart": 1,
        "spare-underwear-change-of-clothes": 1,
        "staedtler-oil-pastles": 2,
        "watercolour-paint-palettes-12-colour-set": 1,
        "whiteboard-eraser": 2,
        "whiteboard-marker-pack-red-blue-green-and-black": 2,
        "year-1-exercise-books-48-page": 1
      },
      "year2": {
        "a3-art-sketch-pad-spirax": 1,
        "a4-quad-ruled-exercise-books-10mm": 1,
        "a4-paper-ream": 2,
        "a4-year-2-exercise-books": 7,
        "avery-zipper-mesh-bag-a3": 1,
        "bic-whiteboard-markers-black-green-red-blue-x2": 8,
        "botany-book": 1,
        "box-tissues": 1,
        "erasers-large": 6,
        "faber-castell-12pkt-coloured-pencils-triangular": 2,
        "headphones1": 1,
        "highlighters-4-pack": 2,
        "library-bag": 1,
        "olympic-minisaurus-scrapbook-64-page": 2,
        "medium-tartan-fabric-pencil-case": 1,
        "pkt-triangular-shape-textas": 2,
        "plastic-document-wallet-clear-with-velcro": 5,
        "ruler-30cm-wooden": 1,
        "scissors": 1,
        "scrapbooks-64-page": 6,
        "sharpener-with-container": 2,
        "soundwaves-extended-student-chart": 1,
        "staedtler-hb-pencils-triangular": 20,
        "staedtler-oil-pastels": 1,
        "uhu-glue-sticks-40g": 7,
        "watercolour-paint-palatte-12-colour-set": 1,
        "whiteboard-eraser": 1
      },
      "year3": {
        "4-pack-highlighters": 1,
        "a3-sketch-pad": 1,
        "a4-clipboard-folder-one-that-closes-has-a-cover": 1,
        "a4-paper-ream": 2,
        "a4-quad-ruled-exercise-books-10mm-48-page": 1,
        "a4-year-3-4-exercise-books-48pg-red-blue-ruled": 4,
        "bic-whiteboard-marker-pack-red-blue-black-green": 1,
        "box-tissues": 2,
        "clear-plastic-document-wallet": 2,
        "erasers": 6,
        "faber-castell-10-pack-pens-non-connector": 2,
        "faber-castell-12pkt-coloured-pencils": 2,
        "headphones1": 1,
        "library-bag": 1,
        "pencil-case-small": 1,
        "ruler-30cm-wooden": 1,
        "scissors": 1,
        "scrapbooks": 6,
        "sharpener-plastic-barrel": 2,
        "soundwaves-extended-student-chart": 1,
        "staedtler-hb-pencils-20pkt": 2,
        "staedtler-oil-pastels": 1,
        "uhu-glue-sticks-40g": 6,
        "whiteboard-a4-size": 1,
        "whiteboard-eraser": 1
      },
      "year3/4": {
        "4-pack-highlighters": 1,
        "a3-sketch-pad": 1,
        "a4-clipboard-folder-one-that-closes-has-a-cover": 1,
        "a4-paper-ream": 2,
        "a4-quad-ruled-exercise-books-10mm-48-page": 1,
        "a4-year-3-4-exercise-books-48pg-red-blue-ruled": 4,
        "bic-whiteboard-marker-pack-red-blue-black-green": 1,
        "box-tissues": 2,
        "clear-plastic-document-wallet": 2,
        "erasers": 6,
        "faber-castell-10-pack-pens-non-connector": 2,
        "faber-castell-12pkt-coloured-pencils": 2,
        "headphones1": 1,
        "library-bag": 1,
        "pencil-case-small": 1,
        "ruler-30cm-wooden": 1,
        "scissors": 1,
        "scrapbooks": 6,
        "sharpener-plastic-barrel": 2,
        "soundwaves-extended-student-chart": 1,
        "staedtler-hb-pencils-20pkt": 2,
        "staedtler-oil-pastels": 1,
        "uhu-glue-sticks-40g": 6,
        "whiteboard-a4-size": 1,
        "whiteboard-eraser": 1
      },
      "year4": {
        "a3-sketch-book-spirax": 1,
        "a4-10mm-48-page-grid-book": 4,
        "a4-clipboard-folder": 1,
        "a4-grade-3-4-ruled-exercise-books-48-pg": 12,
        "a4-paper-ream": 2,
        "box-tissues": 1,
        "calculator": 1,
        "display-folder-20-pckets": 1,
        "erasers-1-per-term": 6,
        "faber-castell-coloured-pencils-12-s": 2,
        "faber-castell-felt-pens-10-s": 2,
        "headphones-with-volume-control": 1,
        "medium-red-pens": 2,
        "pack-of-highlighters": 2,
        "pack-of-whiteboard-markers-black-green-red-blue": 2,
        "pencil-case": 1,
        "pencil-sharpener-with-container": 2,
        "plastic-document-wallets-velcro": 4,
        "scissors": 1,
        "scrapbooks": 2,
        "sharpie-permanent-marker-black": 2,
        "soundwaves-extended-student-chart": 1,
        "staedtler-hb-pencils": 20,
        "staedtler-oil-pastels": 1,
        "thin-ruler-30cm-no-bendy-rulers-wooden": 2,
        "uhu-glue-sticks-40g": 6,
        "whiteboard-eraser": 2
      },
      "year4/5": {
        "a3-sketch-book-spirax": 1,
        "a4-10mm-48-page-grid-book": 4,
        "a4-clipboard-folder": 1,
        "a4-grade-3-4-ruled-exercise-books-48-pg": 12,
        "a4-exercise-books-stapled-96-page": 12,
        "a4-paper-ream": 2,
        "box-tissues": 1,
        "calculator": 1,
        "display-folder-20-pckets": 1,
        "erasers-1-per-term": 6,
        "faber-castell-coloured-pencils-12-s": 2,
        "faber-castell-felt-pens-10-s": 2,
        "headphones-with-volume-control": 1,
        "medium-red-pens": 2,
        "pack-of-highlighters": 2,
        "pack-of-whiteboard-markers-black-green-red-blue": 2,
        "pencil-case": 1,
        "pencil-sharpener-with-container": 2,
        "plastic-document-wallets-velcro": 4,
        "scissors": 1,
        "scrapbooks": 2,
        "sharpie-permanent-marker-black": 2,
        "soundwaves-extended-student-chart": 1,
        "staedtler-hb-pencils": 20,
        "staedtler-oil-pastels": 1,
        "thin-ruler-30cm-no-bendy-rulers-wooden": 2,
        "uhu-glue-sticks-40g": 6,
        "whiteboard-eraser": 1
      },
      "year5": {
        "a3-sketch-book-non-spiral-preferred": 1,
        "a4-10mm-grid-books": 2,
        "a4-exercise-books-128-page": 7,
        "a4-paper-ream": 2,
        "calculator": 1,
        "clipboard-folder-from-previous-year": 1,
        "erasers": 6,
        "fine-point-0-3-size-permanent-marker-black": 2,
        "fine-point-sharpies-black": 2,
        "uhu-glue-sticks-40g": 3,
        "hb-pencils-20-kt": 2,
        "headphones-with-volume-control": 1,
        "highlighter-pen-blue-green-pink-orange-yellow": 5,
        "library-bag": 1,
        "medium-red-pens": 2,
        "mini-whitebaord": 1,
        "packet-of-coloured-pencils": 1,
        "packet-of-texta-pens": 1,
        "pencil-case": 1,
        "pencil-sharpener-with-container": 2,
        "plastic-document-wallets-from-previous-year": 2,
        "scissors": 1,
        "soundwaves-extended-student-chart": 1,
        "staedtler-oil-pastel-crayons-25s": 1,
        "tissue-boxes": 2,
        "usb": 1,
        "whiteboard-eraser": 2,
        "whiteboard-markers-black-red-green-blue": 8,
        "wooden-30cm-rulers": 2
      },
      "year5/6": {
        "a3-sketch-pad-30-pages": 1,
        "a4-botany-exercise-book-must-be-a4": 2,
        "a4-clipboard-folder": 1,
        "a4-display-book-must-be-a4": 1,
        "a4-exercise-books-stapled-96-page": 10,
        "a4-grid-book-48-page-7mm": 2,
        "a4-paper-ream": 2,
        "bic-whiteboard-markers-blue-black-red-green": 4,
        "box-of-tissues": 1,
        "calculator": 1,
        "erasers": 2,
        "faber-castell-colouring-in-pencils": 1,
        "faber-castell-felt-pens-pk-10-connectors": 1,
        "fine-point-0-3-size-permanent-marker-black": 1,
        "fine-point-1-size-permanent-marker-black": 1,
        "hi-lighters-blue-pink-green": 5,
        "headphones-with-volume-control": 1,
        "medium-blue-biro": 2,
        "medium-red-biro": 2,
        "pencil-case-bring-from-previous-year": 1,
        "plastic-document-wallet": 2,
        "post-it-note-stack-small": 1,
        "scissors": 1,
        "soundwaves-extended-student-chart": 1,
        "staedtler-hb-pencils": 20,
        "staedtler-oil-pastels-25s": 1,
        "uhu-glue-sticks-40g": 4,
        "usb-4gb": 1,
        "whiteboard-eraser": 1,
        "wooden-ruler-30cm": 1
      },
      "year6": {
        "a3-sketch-pad-30-pages": 1,
        "a4-botany-exercise-book-must-be-a4": 2,
        "a4-clipboard-folder": 1,
        "a4-display-book-must-be-a4": 1,
        "a4-exercise-books-stapled-96-page": 10,
        "a4-grid-book-48-page-7mm": 2,
        "a4-paper-ream": 2,
        "bic-whiteboard-markers-blue-black-red-green": 4,
        "box-of-tissues": 1,
        "calculator": 1,
        "erasers": 2,
        "faber-castell-colouring-in-pencils": 1,
        "faber-castell-felt-pens-pk-10-connectors": 1,
        "fine-point-0-3-size-permanent-marker-black": 1,
        "fine-point-1-size-permanent-marker-black": 1,
        "hi-lighters-blue-pink-green": 5,
        "headphones-with-volume-control": 1,
        "medium-blue-biro": 2,
        "medium-red-biro": 2,
        "pencil-case-bring-from-previous-year": 1,
        "plastic-document-wallet": 2,
        "post-it-note-stack-small": 1,
        "scissors": 1,
        "soundwaves-extended-student-chart": 1,
        "staedtler-hb-pencils": 20,
        "staedtler-oil-pastels-25s": 1,
        "uhu-glue-sticks-40g": 4,
        "usb-4gb": 1,
        "whiteboard-eraser": 1,
        "wooden-ruler-30cm": 1
      }
    }
  },
  "yugumbirstateschool": {
    "2026": {
      "prep": {
        "a4-copy-paper-ream": 1,
        "a4-size-whiteboard-magnetic-double-sided": 1,
        "box-of-tissues1": 2,
        "coloured-markers-12-pack": 1,
        "coloured-pencils": 2,
        "crayons-twistable-12-pack": 2,
        "display-book-a4-20-pockets": 1,
        "glue-sticks-35-gms": 4,
        "headphones1": 1,
        "highlighter": 1,
        "library-bag1": 1,
        "multilmedia-headphones": 1,
        "pencil-case1": 1,
        "pencil-triangular-grip": 10,
        "plain-white-eraser": 1,
        "scissors-130mm": 1,
        "scrapbook-64-pages": 3,
        "small-magnetic-whiteboard-eraser": 1,
        "white-board-markers-4-pack-multicolour": 4,
        "writer-premium-story-book-64-pages": 4
      },
      "year1": {
        "a4-copy-paper-ream": 1,
        "a4-whiteboard-magnetic-double-sided": 1,
        "botany-book-a4-size-qld-year-1-24mm-48-pages": 2,
        "box-of-tissues1": 2,
        "clear-plastic-document-wallet1": 1,
        "coloured-pencils-12-pack": 2,
        "crayon-twistable-12-pack": 2,
        "exercise-book-a4-size-qld-year-1": 2,
        "glue-sticks-35-gms": 5,
        "graphite-pencil-hb-box-12": 2,
        "grid-book-a4-size-10mm-96-pages": 1,
        "highlighters-4-pack1": 1,
        "library-bag-1": 1,
        "pencil-case-to-hold-30cm-ruler": 1,
        "plain-white-eraser": 8,
        "scissors-130mm": 1,
        "scrap-book-64-pages": 4,
        "sharpener-2-hole-with-canister": 2,
        "small-magnetic-whiteboard-eraser": 1,
        "whiteboard-markers-4-pack-multicolour": 2,
        "writer-330x240mm-student-notebook-year-1": 4,
        "wooden-ruler-30cm1": 1
      },
      "year2": {
        "a4-copy-paper-ream": 1,
        "a4-whiteboard-magnetic-double-sided": 1,
        "box-of-tissues1": 2,
        "coloured-markers-12-pack": 1,
        "coloured-pencils-12-pack": 2,
        "crayons-twistable-12-pack": 1,
        "document-wallet-a4-any-color": 1,
        "exercise-book-a4-qld-year-2-48-pages": 16,
        "glue-sticks-35-gms": 5,
        "graphite-pencils-hb-box-12": 2,
        "grid-book-a4-10-mm-96-pages": 1,
        "highlighter-4-pack": 1,
        "library-bag-1": 1,
        "microfibre-cloth": 1,
        "pencil-case1": 1,
        "pencil-case-to-whold-30cm-ruler": 1,
        "plain-white-eraser": 6,
        "scarpbook-64-pages": 3,
        "scissors-130mm": 1,
        "sharpener-2-hole-with-canister": 2,
        "whiteboard-markers-4-pack-multicolour": 4,
        "wooden-ruler-30cm1": 1
      },
      "year3": {
        "a4-copy-paper-ream": 1,
        "a4-whiteboard-magnetic-double-sided": 1,
        "box-of-tissues1": 2,
        "coloured-markers-12-packs": 1,
        "coloured-pencils-12-pack": 2,
        "document-wallet-a4-any-colour": 2,
        "exercise-book-a4-year-3-4-12mm-96-pages": 16,
        "glue-sticks-35-g": 4,
        "graphite-pencils-hb-box-12": 2,
        "grid-book-a4-size-a0mm-96-pages": 2,
        "highlighters-4-pack1": 1,
        "library-bag-1": 1,
        "microfibre-cloth": 1,
        "pencil-case1": 1,
        "plain-white-eraser": 4,
        "recorder": 1,
        "red-pen": 4,
        "scarpbook-64-pages": 1,
        "scissors-130mm": 1,
        "sharpener-2-hole-with-canister": 1,
        "whiteboard-markers-4-pack-mulicolour": 3,
        "wooden-ruler-30cm1": 1
      },
      "year4": {
        "a4-copy-paper-ream": 1,
        "a4-whiteboard-magnetic-double-sided": 1,
        "box-of-tissues1": 2,
        "coloured-markers-12-packs": 1,
        "coloured-pencils-12-pack": 2,
        "document-wallet-a4-any-colour": 3,
        "exercise-book-a4-year-3-4-12mm-96-pages": 10,
        "glue-sticks-35-g": 6,
        "graphite-pencils-hb-box-12": 2,
        "grid-book-a4-size-a4-10mm-96-pages": 2,
        "highlighters-4-pack1": 2,
        "library-bag-1": 1,
        "microfibre-cloth": 1,
        "pencil-case1": 1,
        "plain-white-eraser": 4,
        "red-ball-point-pen": 4,
        "scissors-130mm": 1,
        "sharpner-2-hole-with-canister": 2,
        "sticky-note": 2,
        "whiteboard-markers-4-pack-mulicolour": 2,
        "wooden-ruler-30cm1": 1
      },
      "year5": {
        "a4-whiteboard-magnetic-double-sided": 1,
        "box-of-tissues1": 2,
        "coloured-markers-12-packs": 1,
        "coloured-pencils-12-pack": 1,
        "document-wallet-a4-any-colour": 1,
        "exercise-book-a4-8mm-96-pages": 10,
        "glue-sticks-35-g": 4,
        "graphite-pencils-hb-box-12": 3,
        "grid-book-a4-size-a0mm-96-pages": 4,
        "headphones1": 1,
        "highlighters-4-pack1": 1,
        "library-bag-1": 1,
        "microfibre-cloth": 1,
        "pencil-case1": 1,
        "plain-white-eraser": 4,
        "red-ball-point-pen": 4,
        "ruled-office-note-pad-a4-size": 1,
        "scissors-130mm": 1,
        "sharpner-2-hole-with-canister": 2,
        "sticky-note-3-colours": 1,
        "whiteboard-markers-4-pack-mulicolour": 2,
        "wooden-ruler-30cm1": 1
      },
      "year6": {
        "a4-copy-paper-ream": 1,
        "a4-whiteboard-magnetic-double-sided": 1,
        "blue-ball-point-pen": 2,
        "box-of-tissues1": 2,
        "calculator1": 1,
        "coloured-markers-12-packs": 1,
        "coloured-pencils-12-pack": 1,
        "document-wallet-a4-any-colour": 1,
        "exercise-book-a4-8mm-96-pages": 8,
        "glue-sticks-35-g": 4,
        "graphite-pencils-hb-box-12": 4,
        "grid-book-a4-size-a0mm-96-pages": 4,
        "headphones1": 1,
        "highlighters-4-pack1": 2,
        "library-bag-1": 1,
        "microfibre-cloth": 1,
        "pencil-case1": 1,
        "plain-white-eraser": 6,
        "red-ball-point-pen": 4,
        "ruled-office-note-pad-a4-size": 1,
        "scissors-130mm": 1,
        "sharpner-2-hole-with-canister": 2,
        "sticky-note-3-colours": 1,
        "whiteboard-markers-4-pack-mulicolour": 3,
        "wooden-ruler-30cm1": 1
      }
    }
  },
  "stbernardinesschoolregentspark": {
    "2026": {
      "prep": {
        "st-bernardines-school-regents-park-2026-prep-scrapbook-amh-prep-half-page-design-yellow": 2,
        "st-bernardines-school-regents-park-2026-prep-clear-mesh-pouch-a4": 1,
        "st-bernardines-school-regents-park-2026-prep-scrapbook-72-page-70gsm": 4,
        "st-bernardines-school-regents-park-2026-prep-crayons-twist-dats-10s": 2,
        "st-bernardines-school-regents-park-2026-prep-glue-stick-stuk-36gm": 6,
        "st-bernardines-school-regents-park-2026-prep-scissors-orange-handle-130mm-vinyl-wallet": 1,
        "st-bernardines-school-regents-park-2026-prep-scissors-rounded-ends-green-handle-left-handed-130mm": 1,
        "st-bernardines-school-regents-park-2026-prep-marker-whiteboard-wallet-of-4-bullet-tip-asst-colours": 2,
        "st-bernardines-school-regents-park-2026-prep-scrapbook-mini-pp-cover-64pg-animal-magic": 1,
        "st-bernardines-school-regents-park-2026-prep-pencil-hb-triangular-junior-grip-micador": 4,
        "st-bernardines-school-regents-park-2026-prep-eraser-micador-large-3020": 1,
        "st-bernardines-school-regents-park-2026-prep-heads-up-headphones-basic-overhead-3-5mm-jack": 1
      },
      "year1": {
        "st-bernardines-school-regents-park-2026-year1-exercise-book-a4-48-pg-year-1-ruled-red-margin": 3,
        "st-bernardines-school-regents-park-2026-year1-scrapbook-amh-prep-half-page-design-yellow": 1,
        "st-bernardines-school-regents-park-2026-year1-clear-mesh-pouch-a4": 1,
        "st-bernardines-school-regents-park-2026-year1-play-activity-scrapbook-plain-and-lined-pages-64-pg-10mm-plain-playbook": 6,
        "st-bernardines-school-regents-park-2026-year1-marbig-polypick-f-c-document-wallet-assorted": 1,
        "st-bernardines-school-regents-park-2026-year1-crayons-twist-dats-10s": 1,
        "st-bernardines-school-regents-park-2026-year1-glue-stick-osmer-blue-40g": 8,
        "st-bernardines-school-regents-park-2026-year1-texta-nylorite-colouring-marker-pk-of-12": 1,
        "st-bernardines-school-regents-park-2026-year1-scissors-155mm-blue-handle-osmer-right-handed-or": 1,
        "st-bernardines-school-regents-park-2026-year1-scissors-158mm-green-handle-osmer-left-handed": 1,
        "st-bernardines-school-regents-park-2026-year1-pencil-hb-micador-essential-fsc-100-box-x-20": 1,
        "st-bernardines-school-regents-park-2026-year1-pinstripe-whiteboard-marker-assorted-pk-of-4": 2,
        "st-bernardines-school-regents-park-2026-year1-eraser-micador-large-3020": 2,
        "st-bernardines-school-regents-park-2026-year1-headphones-mconnected-multimedia-35mm-jack-on-ear-01-no-mic": 1,
        "st-bernardines-school-regents-park-2026-year1-writing-time-1-queensland-9781741352801": 1,
        "st-bernardines-school-regents-park-2026-year1-book-bag-for-library-navy": 1
      },
      "year2": {
        "st-bernardines-school-regents-park-2026-year2-exercise-book-a4-48-pg-year-2-ruled-red-margin": 6,
        "st-bernardines-school-regents-park-2026-year2-scrapbook-small-mini-64pg-100gsm-168-x-240mm": 1,
        "st-bernardines-school-regents-park-2026-year2-play-activity-scrapbook-plain-and-lined-pages-64-pg-10mm-plain-playbook": 7,
        "st-bernardines-school-regents-park-2026-year2-marbig-polypick-f-c-document-wallet-assorted": 1,
        "st-bernardines-school-regents-park-2026-year2-crayons-twist-dats-10s": 1,
        "st-bernardines-school-regents-park-2026-year2-coloured-pencils-dats-10s": 1,
        "st-bernardines-school-regents-park-2026-year2-glue-stick-osmer-blue-40g": 5,
        "st-bernardines-school-regents-park-2026-year2-pencil-hb-premium-wood-case-graphite-box-x20": 1,
        "st-bernardines-school-regents-park-2026-year2-whiteboard-eraser-mini-magnetic": 1,
        "st-bernardines-school-regents-park-2026-year2-eraser-micador-large-3020": 4,
        "st-bernardines-school-regents-park-2026-year2-headphones-mconnected-multimedia-on-ear-with-microphone-03-35mm-jack": 1,
        "st-bernardines-school-regents-park-2026-year2-writing-time-2-queensland-9781741352818": 1,
        "st-bernardines-school-regents-park-2026-year2-clear-mesh-pouch-a4": 1,
        "st-bernardines-school-regents-park-2026-year2-book-bag-for-library-navy": 1,
        "st-bernardines-school-regents-park-2026-year2-scissors-155mm-blue-handle-osmer-right-handed-or": 1,
        "st-bernardines-school-regents-park-2026-year2-scissors-158mm-green-handle-osmer-left-handed": 1,
        "st-bernardines-school-regents-park-2026-year2-music-exercise-book-96-pg-225x175mm": 1,
        "st-bernardines-school-regents-park-2026-year2-music-pencil-case-a4-two-zip-tartan": 1,
        "st-bernardines-school-regents-park-2026-year2-music-pencil-hb-single": 1,
        "st-bernardines-school-regents-park-2026-year2-music-eraser-micador-large-3020": 1
      },
      "year3": {
        "st-bernardines-school-regents-park-2026-year3-exercise-book-a4-year-3-4-ruled-red-margin-96-page": 4,
        "st-bernardines-school-regents-park-2026-year3-graph-book-a4-10mm-48pg": 1,
        "st-bernardines-school-regents-park-2026-year3-play-activity-scrapbook-plain-and-lined-pages-64-pg-10mm-plain-playbook": 8,
        "st-bernardines-school-regents-park-2026-year3-crayons-twist-dats-10s": 2,
        "st-bernardines-school-regents-park-2026-year3-coloured-pencils-dats-10s": 2,
        "st-bernardines-school-regents-park-2026-year3-highlighters-pinstripe-wallet-of-4-blue-yellow-pink-green": 1,
        "st-bernardines-school-regents-park-2026-year3-glue-stick-stuk-36gm": 6,
        "st-bernardines-school-regents-park-2026-year3-pencil-hb-premium-wood-case-graphite-box-x20": 1,
        "st-bernardines-school-regents-park-2026-year3-ruler-plastic-school-30cm-clear": 1,
        "st-bernardines-school-regents-park-2026-year3-sharpener-metal-1-hole": 2,
        "st-bernardines-school-regents-park-2026-year3-tech-iq-stylus-pen": 1,
        "st-bernardines-school-regents-park-2026-year3-eraser-micador-large-3020": 4,
        "st-bernardines-school-regents-park-2026-year3-basic-earphone-buds-with-pouch": 1,
        "st-bernardines-school-regents-park-2026-year3-writing-time-3-queensland-9781741352825": 1,
        "st-bernardines-school-regents-park-2026-year3-clear-mesh-pouch-a4": 1,
        "st-bernardines-school-regents-park-2026-year3-book-bag-for-library-navy": 1,
        "st-bernardines-school-regents-park-2026-year3-pencil-case-a4-two-zip-tartan": 1,
        "st-bernardines-school-regents-park-2026-year3-scissors-155mm-blue-handle-osmer-right-handed-or": 1,
        "st-bernardines-school-regents-park-2026-year3-scissors-158mm-green-handle-osmer-left-handed": 1,
        "st-bernardines-school-regents-park-2026-year3-music-exercise-book-96-pg-225x175mm": 1,
        "st-bernardines-school-regents-park-2026-year3-music-pencil-case-a4-two-zip-tartan": 1,
        "st-bernardines-school-regents-park-2026-year3-music-pencil-hb-single": 1,
        "st-bernardines-school-regents-park-2026-year3-music-faber-castell-dust-free-eraser-white-large-with-sleeve": 1
      },
      "year4": {
        "st-bernardines-school-regents-park-2026-year4-writer-sketch-block-a3-25-leaf": 1,
        "st-bernardines-school-regents-park-2026-year4-exercise-book-96-pg-225x175mm": 1,
        "st-bernardines-school-regents-park-2026-year4-grid-book-a4-10mm-96pg": 3,
        "st-bernardines-school-regents-park-2026-year4-scrapbook-mega-64-pg-100gsm": 2,
        "st-bernardines-school-regents-park-2026-year4-marbig-polypick-f-c-document-wallet-clear": 1,
        "st-bernardines-school-regents-park-2026-year4-crayons-twist-dats-10s": 1,
        "st-bernardines-school-regents-park-2026-year4-coloured-pencils-dats-10s": 1,
        "st-bernardines-school-regents-park-2026-year4-highlighters-pinstripe-wallet-of-4-blue-yellow-pink-green": 1,
        "st-bernardines-school-regents-park-2026-year4-glue-stick-stuk-36gm": 6,
        "st-bernardines-school-regents-park-2026-year4-texta-nylorite-colouring-marker-pk-of-12": 1,
        "st-bernardines-school-regents-park-2026-year4-calculator-jastek-pocket-plastic-8-digit": 1,
        "st-bernardines-school-regents-park-2026-year4-pencil-hb-premium-wood-case-graphite-box-x20": 1,
        "st-bernardines-school-regents-park-2026-year4-pinstripe-whiteboard-marker-assorted-pk-of-4": 1,
        "st-bernardines-school-regents-park-2026-year4-exercise-book-protext-cover-a4-yr-3-4-96-pg-turtle": 9,
        "st-bernardines-school-regents-park-2026-year4-pen-ballpoint-medium-red": 2,
        "st-bernardines-school-regents-park-2026-year4-marker-sharpie-permanent-fine-black-1mm": 2,
        "st-bernardines-school-regents-park-2026-year4-ruler-plastic-school-30cm-clear": 1,
        "st-bernardines-school-regents-park-2026-year4-faber-castell-single-hole-sharpener-with-catch-assorted-colours": 1,
        "st-bernardines-school-regents-park-2026-year4-eraser-micador-large-3020": 4,
        "st-bernardines-school-regents-park-2026-year4-basic-earphone-buds-with-pouch": 1,
        "st-bernardines-school-regents-park-2026-year4-book-bag-for-library-navy": 1,
        "st-bernardines-school-regents-park-2026-year4-scissors-155mm-blue-handle-osmer-right-handed-or": 1,
        "st-bernardines-school-regents-park-2026-year4-scissors-158mm-green-handle-osmer-left-handed": 1,
        "st-bernardines-school-regents-park-2026-year4-tech-iq-stylus-pen": 1,
        "st-bernardines-school-regents-park-2026-year4-music-exercise-book-96-pg-225x175mm": 1,
        "st-bernardines-school-regents-park-2026-year4-music-pencil-case-a4-two-zip-tartan": 1,
        "st-bernardines-school-regents-park-2026-year4-music-recorder-yamaha-yrs24b": 1,
        "st-bernardines-school-regents-park-2026-year4-music-pencil-hb-single": 1,
        "st-bernardines-school-regents-park-2026-year4-music-faber-castell-dust-free-eraser-white-large-with-sleeve": 1
      },
      "year5": {
        "st-bernardines-school-regents-park-2026-year5-writer-sketch-block-a3-25-leaf": 1,
        "st-bernardines-school-regents-park-2026-year5-exercise-book-a4-96-pg-with-margin": 6,
        "st-bernardines-school-regents-park-2026-year5-exercise-book-96-pg-225x175mm": 1,
        "st-bernardines-school-regents-park-2026-year5-grid-book-a4-10mm-48pg": 6,
        "st-bernardines-school-regents-park-2026-year5-name-pencil-case-small-23-5-x-13cm-orange-blue-zip": 1,
        "st-bernardines-school-regents-park-2026-year5-display-book-a4-20-pocket-assorted": 1,
        "st-bernardines-school-regents-park-2026-year5-marbig-polypick-f-c-document-wallet-assorted": 1,
        "st-bernardines-school-regents-park-2026-year5-coloured-pencils-dats-10s": 1,
        "st-bernardines-school-regents-park-2026-year5-osmer-oil-pastels-12": 1,
        "st-bernardines-school-regents-park-2026-year5-glue-stick-stuk-36gm": 3,
        "st-bernardines-school-regents-park-2026-year5-pencil-hb-premium-wood-case-graphite-box-x20": 1,
        "st-bernardines-school-regents-park-2026-year5-pinstripe-whiteboard-marker-assorted-pk-of-4": 1,
        "st-bernardines-school-regents-park-2026-year5-marker-whiteboard-bullet-tip-black": 1,
        "st-bernardines-school-regents-park-2026-year5-pen-ballpoint-medium-red": 2,
        "st-bernardines-school-regents-park-2026-year5-pen-ballpoint-medium-blue": 2,
        "st-bernardines-school-regents-park-2026-year5-marker-sharpie-permanent-fine-black-1mm": 2,
        "st-bernardines-school-regents-park-2026-year5-ruler-wooden-30cm-unpolished": 1,
        "st-bernardines-school-regents-park-2026-year5-sharpener-metal-1-hole": 1,
        "st-bernardines-school-regents-park-2026-year5-eraser-micador-large-3020": 2,
        "st-bernardines-school-regents-park-2026-year5-protractor-half-circle-180-degree-10cm": 1,
        "st-bernardines-school-regents-park-2026-year5-basic-earphone-buds-with-pouch": 1,
        "st-bernardines-school-regents-park-2026-year5-book-bag-for-library-navy": 1,
        "st-bernardines-school-regents-park-2026-year5-marbig-polypick-f-c-document-wallet-clear": 1,
        "st-bernardines-school-regents-park-2026-year5-recorder-yamaha-yrs24b": 1,
        "st-bernardines-school-regents-park-2026-year5-calculator-sharp-el243s": 1,
        "st-bernardines-school-regents-park-2026-year5-scissors-155mm-blue-handle-osmer-right-handed-or": 1,
        "st-bernardines-school-regents-park-2026-year5-scissors-158mm-green-handle-osmer-left-handed": 1,
        "st-bernardines-school-regents-park-2026-year5-tech-iq-stylus-pen": 1,
        "st-bernardines-school-regents-park-2026-year5-music-exercise-book-96-pg-225x175mm": 1,
        "st-bernardines-school-regents-park-2026-year5-music-pencil-case-a4-two-zip-tartan": 1,
        "st-bernardines-school-regents-park-2026-year5-music-pencil-hb-single": 1,
        "st-bernardines-school-regents-park-2026-year5-music-eraser-micador-large-3020": 1
      },
      "year6": {
        "st-bernardines-school-regents-park-2026-year6-exercise-book-a4-96-pg-with-margin": 8,
        "st-bernardines-school-regents-park-2026-year6-diary-2026-budget": 1,
        "st-bernardines-school-regents-park-2026-year6-graph-book-a4-10mm-48pg": 3,
        "st-bernardines-school-regents-park-2026-year6-scrapbook-72-page-70gsm": 1,
        "st-bernardines-school-regents-park-2026-year6-pencil-case-blue-tartan-23cm-x15-x-cm": 1,
        "st-bernardines-school-regents-park-2026-year6-marbig-polypick-f-c-document-wallet-assorted": 2,
        "st-bernardines-school-regents-park-2026-year6-coloured-pencils-dats-10s": 1,
        "st-bernardines-school-regents-park-2026-year6-highlighters-pinstripe-wallet-of-4-blue-yellow-pink-green": 1,
        "st-bernardines-school-regents-park-2026-year6-glue-stick-stuk-36gm": 2,
        "st-bernardines-school-regents-park-2026-year6-pencil-hb-premium-wood-case-graphite-box-x20": 1,
        "st-bernardines-school-regents-park-2026-year6-artline-supreme-fine-liner-pen-0-4mm-black": 2,
        "st-bernardines-school-regents-park-2026-year6-pen-ballpoint-medium-red": 2,
        "st-bernardines-school-regents-park-2026-year6-pen-ballpoint-medium-blue": 2,
        "st-bernardines-school-regents-park-2026-year6-marker-sharpie-permanent-fine-black-1mm": 1,
        "st-bernardines-school-regents-park-2026-year6-ruler-plastic-school-30cm-clear": 1,
        "st-bernardines-school-regents-park-2026-year6-sharpener-metal-1-hole": 1,
        "st-bernardines-school-regents-park-2026-year6-eraser-micador-large-3020": 3,
        "st-bernardines-school-regents-park-2026-year6-protractor-half-circle-180-degree-10cm": 1,
        "st-bernardines-school-regents-park-2026-year6-basic-earphone-buds-with-pouch": 1,
        "st-bernardines-school-regents-park-2026-year6-book-bag-for-library-navy": 1,
        "st-bernardines-school-regents-park-2026-year6-recorder-yamaha-yrs24b": 1,
        "st-bernardines-school-regents-park-2026-year6-calculator-sharp-el243s": 1,
        "st-bernardines-school-regents-park-2026-year6-scissors-155mm-blue-handle-osmer-right-handed-or": 1,
        "st-bernardines-school-regents-park-2026-year6-scissors-158mm-green-handle-osmer-left-handed": 1,
        "st-bernardines-school-regents-park-2026-year6-tech-iq-stylus-pen": 1,
        "st-bernardines-school-regents-park-2026-year6-music-exercise-book-96-pg-225x175mm": 1,
        "st-bernardines-school-regents-park-2026-year6-music-pencil-case-a4-two-zip-tartan": 1,
        "st-bernardines-school-regents-park-2026-year6-music-pencil-hb-single": 1,
        "st-bernardines-school-regents-park-2026-year6-music-eraser-micador-large-3020": 1
      }
    }
  }
});
